var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndiaIcon = function SvgIndiaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#india-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M14 0C8.449 0 3.653 3.23 1.388 7.913H26.61C24.346 3.23 19.55 0 14 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M14 28c5.55 0 10.346-3.23 12.61-7.913H1.39C3.653 24.77 8.449 28 13.999 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M14 18.87a4.87 4.87 0 1 0 0-9.74 4.87 4.87 0 0 0 0 9.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M14 17.044a3.043 3.043 0 1 0 0-6.087 3.043 3.043 0 0 0 0 6.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "m14 10.244.94 2.13 2.313-.252L15.878 14l1.375 1.878-2.314-.252-.938 2.13-.94-2.13-2.313.252L12.123 14l-1.375-1.878 2.314.252z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "india-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgIndiaIcon;